/* global breakpointMd, windowWidth, attachEvent, slideUp, slideDown */

// **********************************************************
// Main menu dropdown
// **********************************************************
const menuLinkElement = document.querySelectorAll('.has-submenu.menu__item');
const menuOverlay = document.querySelectorAll('.menu-overlay')[0];

function toggleSubMenu(ev) {
  const menuItem = ev.target.closest('.menu__item');
  const menuLink = menuItem.querySelectorAll('.menu__link.level-1')[0];

  if (menuItem.classList.contains('is-sub-open')) {
    menuItem.classList.remove('is-sub-open');
    menuOverlay.classList.remove('is-visible');
    menuLink.setAttribute('aria-expanded', 'false');
  } else {
    menuItem.classList.add('is-sub-open');
    menuOverlay.classList.add('is-visible');
    menuLink.setAttribute('aria-expanded', 'true');
  }

  ev.preventDefault();
  return false;
}

if (menuLinkElement) {
  menuLinkElement.forEach((elem) => {
    elem.addEventListener('mouseenter', (ev) => {
      if (windowWidth() > breakpointMd) {
        toggleSubMenu(ev);
        document.body.classList.toggle('hover-menu');
      }
    });
    elem.addEventListener('mouseleave', (ev) => {
      if (windowWidth() > breakpointMd) {
        toggleSubMenu(ev);
        document.body.classList.toggle('hover-menu');
      }
    });
  });
}

// Close all menus
function closeMenus() {
  const openMenus = document.querySelectorAll('.menu__item');

  openMenus.forEach((elem) => {
    if (elem.classList.contains('is-sub-open')) {
      const menuDropdown = elem.querySelectorAll('.menu__dropdown')[0];
      const menuLink = elem.querySelectorAll('.menu__link.level-1')[0];

      slideUp(menuDropdown, 300);
      elem.classList.remove('is-sub-open');
      menuLink.setAttribute('aria-expanded', 'false');
    }
  });
}

// Menu toggle
attachEvent('.menu__arrow', 'click', (ev) => {
  if (windowWidth() < breakpointMd) {
    const menuItem = ev.target.closest('.menu__item');
    const menuLink = menuItem.querySelectorAll('.menu__link.level-1')[0];
    const menuDropdown = menuItem.querySelectorAll('.menu__dropdown')[0];

    if (menuItem.classList.contains('is-sub-open')) {
      closeMenus();
    } else {
      closeMenus();
      menuItem.classList.add('is-sub-open');
      slideDown(menuDropdown, 300);
      menuLink.setAttribute('aria-expanded', 'true');
    }
  }
});

// // Milan's code, keeping just in case
// attachEvent('.menu__arrow', 'click', (ev) => {
//   if (windowWidth() < breakpointMd) {
//     const arrowParent = ev.target.closest('.menu__item');
//     const menuLink = arrowParent.querySelectorAll('.menu__link.level-1')[0];
//     const menuDropdown = arrowParent.querySelectorAll('.menu__dropdown')[0];

//     if (arrowParent.classList.contains('is-sub-open')) {
//       slideUp(menuDropdown, 300);
//       arrowParent.classList.remove('is-sub-open');
//       menuLink.setAttribute('aria-expanded', 'false');
//     } else {
//       arrowParent.classList.add('is-sub-open');
//       slideDown(menuDropdown, 300);
//       menuLink.setAttribute('aria-expanded', 'true');
//     }
//   }
// });
